/**
 * If the page has js modal triggers:
 *     - listen to click on triggers to open corresponding modal
 *     - listen to click on modal close buttons, close all modals
 */
export default function initModalTriggers() {
  // Get Elements
  const triggers = document.querySelectorAll('.js-modal-trigger');
  const modalCloseButtons = document.querySelectorAll('.js-modal-close, .modal__backdrop:not(.js-modal__disable-backdrop-close)');
  if(!triggers) return;

  // Add click listener to triggers
  // When trigger is clicked, add visible class to corresponding modal
  triggers.forEach((trigger) => {
    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      const targetIdentifier = trigger.getAttribute('data-modal-trigger');
      closeAllModals();

      targetIdentifier && document.querySelector(`.js-modal[data-modal="${targetIdentifier}"]`).classList.add('is-visible');
    })
  });

  // Listen to click opn close buttons
  // Close all open buttons
  modalCloseButtons && modalCloseButtons.forEach((modalCloseButton) => {
    modalCloseButton.addEventListener('click', (event) => {
      event.preventDefault();
      closeAllModals();
    });
  });
}

/**
 * Close all open modals
 */
function closeAllModals() {
  const openModals = document.querySelectorAll('.js-modal.is-visible');
  if(!openModals) return;
  openModals.forEach((openModal) => {
    openModal.classList.remove('is-visible');
  });
}

